const awsExportsProd = {
  aws_project_region: 'eu-central-1', // Replace with your region
  // aws_cognito_identity_pool_id:
  //   'eu-central-1:xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx', // Replace with your Identity Pool ID
  aws_cognito_region: 'eu-central-1', // Replace with your Cognito region
  aws_user_pools_id: 'eu-central-1_7az4lAwMB', // Replace with your User Pool ID
  aws_user_pools_web_client_id: '5m6ksnoiavmdctuq9khr22bt9a', // Replace with your User Pool App Client ID
  oauth: {
    domain: 'gl-prep.auth.eu-central-1.amazoncognito.com', // Replace with your Cognito domain
    scope: ['openid', 'phone', 'email'],
    redirectSignIn: 'https://absite.gaialabs.ai/login', // Adjust with your app's URL
    redirectSignOut: 'https://absite.gaialabs.ai/login', // Adjust with your app's URL
    responseType: 'code'
  }
}

export default awsExportsProd
